import { useEffect } from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useMount = func => useEffect(() => func(), []);

export default useMount;



// WEBPACK FOOTER //
// ./src/js/common/hooks/useMount.js